import { TierToColorClass } from '@/enums'

function stripTierSuffix(label) {
  return String(label || '').replace(/\s*tier$/i, '').trim()
}

export function resolveTrackerTier(business) {
  if (!business?.tier) {
    return { label: 'N/A', className: 'tier--na' }
  }

  const label = stripTierSuffix(business.tier)
  const className = TierToColorClass[label] || 'tier--na'

  return { label, className }
}
